module.exports = __webpack_public_path__ + "static/img/7.d6f7c0bb.png";